import React from "react";
import "../../css/legacy.css";
import Heading from "../../components/Heading";
import { col1 } from "../../Constants/legacyConstant";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import ReactPixel from "react-facebook-pixel";
const DarjiLogo = "https://bawamasalacompany.com/assets/images/Elements/S_Bawa_Sardar_Singh_Bhalla.png";

let duration = 400;

export class LegacyView extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      showTrans: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
  }
  componentDidMount() {
    ReactPixel.init("145006083100066");
    ReactPixel.track("ViewContent", location);
    setTimeout(() => {
      this.setState({
        showTrans: true,
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    this.setState({
      showTrans: true,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0.1,
      },
    });
  }
  render() {
    const { defaultStyle } = this.state;
    const { location } = this.props;
    return (
      <ContentPage>
        <Meta
          title="BMC Estd. 1952 | 7 Decades of Leadership in Spice Products"
          description="Bawa Masala Company, established 1952, is a leading manufacturer of quality spice products delivered globally. Enquire about dealership and bulk orders."
          location={location}
        />
        <div className="global__wrapper" style={{ background: "#e9eef6" }}>
          <div className="legacy__wrapper" style={defaultStyle}>
            <Heading title="Legacy" />
            <div className="panel__1">
              <div className="row __media">
                <div className="col-md-3 __media__left">
                  <img src={DarjiLogo} alt="S_Bawa_Sardar Singh_Bhalla" className="img img-responsive" />
                  <div className="name">S.Bawa Sardar Singh Bhalla</div>
                  <div className="founder">Founder of Bawa Masala Company</div>
                </div>
                <div className="col-md-9 __media__body">
                  After starting in 1952, on a humble note, with a small unit having a capacity to produce merely four basic spices, BMC, thanks to the firm
                  commitment to deliver quality, is today a giant Masala Company.
                  <br />
                  <br />
                  After nearly seven decades of expertise in spice and spice blends, BMC is today renowned in the domestic and international market for being at
                  the forefront with an emphasis on premium quality, constant innovation and consistent delivery on timeless recipes and taste.
                  <br />
                  <br />
                  For good reason. Before hitting the shelf at the outlets, each hygienically produced BMC product undergoes stringent quality tests and is
                  packed to keep the freshness and wholesomeness intact for the consumer. Our hi-tech production plant and diligent supervision at each stage
                  during the production process ensure the quality that is a hallmark of BMC.
                  <br />
                  <br />
                  BMC products offer a vast range of variety, tickling the taste buds of every food lover.
                </div>
              </div>
            </div>
            <div className="panel__2">
              <Heading title="Infrastructure, expertise and process" size="large" />
              <div className="content">
                <div className="sub__heading">
                  Bawa Masala Company has international standard infrastructure, well-poised to meet the daily rigours of global demand for premium Indian
                  spices
                </div>
                <div className="row">
                  {col1.map((item, i) => {
                    return (
                      <div className="col-lg-4 col-sm-6" key={i}>
                        <div className="info">
                          <div className="info-img">
                            <img src={item.imgSrc} alt={item.text} className="" />
                          </div>
                          <div className="info-text">{item.text}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

export default LegacyView;



// WEBPACK FOOTER //
// ./src/pages/legacy/index.js